import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../media-query';

class Component extends BaseComponent {
    constructor() {
        super();
        this.state = { width: window.innerWidth };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    /* eslint-disable complexity */
    render({ breakpoint, orientation, innerHTML }) {
        let doRender = false;

        if (breakpoint) { // these set doRender to true when media type matches MediaQuery
            if (breakpoint == 'is-tiny' && MQ.isTiny()) { // <370px
                doRender = true;
            } else if (breakpoint == 'is-mobile' && MQ.isMobile()) { // <599px
                doRender = true;
            // eslint-disable-next-line max-len
            } else if (breakpoint == 'is-tablet-portrait' && ! MQ.isTabletPortrait()) {//600px to 899px
                doRender = true;
            } else if (breakpoint == 'is-tablet-landscape' && MQ.isTabletLandscape()) {//900px to 1199px
                doRender = true;
            } else if (breakpoint == 'is-large' && MQ.isLarge()) { //>1200px
                doRender = true;
            }
        }

        if (doRender && orientation) { // these do the reverse, negate doRender if they don't match
            if (orientation == 'portrait' && ! MQ.isPortrait()) {
                doRender = false;
            } else if (orientation == 'landscape' && ! MQ.isLandscape()) {
                doRender = false;
            }
        }

        if (doRender) { // finally, render if orientation and/or breakpoint match
            return (
                <media-query
                    breakpoint={breakpoint}
                    orientation={orientation}
                    dangerouslySetInnerHTML={{__html: innerHTML || ''}}
                />
            );
        }

        return null;
    }
    /* eslint-enable complexity */

    updateDimensions = () => {
        this.setState({ width: window.innerWidth });
    }
}

export default connect()(Component);